
export const dateFromTimestamp = (value) => {
  let result = value + "";
  if (result.length < 13) {
    for (let i = result.length; i < 13; i++) {
      result += "0";
    }
  }
  return new Date(result * 1);
}

export const stringFormatDate = (date, options = {
  year: 'numeric', month: 'short', day: 'numeric'
}) => {
  return date.toLocaleDateString("en-US", options);
}